import { render, staticRenderFns } from "./create_mrn.vue?vue&type=template&id=643ec6d2&scoped=true"
import script from "./create_mrn.vue?vue&type=script&lang=js"
export * from "./create_mrn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643ec6d2",
  null
  
)

export default component.exports